import * as messageService from "../../services/message.service";
import * as payPeriodService from '../../services/payPeriod.service';


const state = {
    payPeriodAll:[],
    payPeriodAllActive:[],
};

const getters = {
    gettPayPeriodAll:state => (state.payPeriodAll),
    gettPayPeriodAllActive:state => (state.payPeriodAllActive),
};

const actions = {
    async fetchPayPeriodAll({ commit } ){
        try {
            const response = await payPeriodService.all();

            commit('setPayPeriodAll', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchPayPeriodAllActive({ commit } ){
        try {
            const response = await payPeriodService.allActive();

            commit('setPayPeriodAllActive', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
};

const mutations = {
    setPayPeriodAll:(state, res) => (
        state.payPeriodAll =  res
    ),
    setPayPeriodAllActive:(state, res) => (
        state.payPeriodAllActive =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}